import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import React, { useState, useCallback, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import TableChartIcon from "@mui/icons-material/TableChart";
import { useNavigate } from "react-router-dom";
import Chart from "chart.js/auto";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun } from "docx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useDispatch, useSelector } from "react-redux";
import { fetchStatus } from "../../../../../store/slices/statusSlice";
import { setPotentialFromDateRedux, setPotentialStatusRedux, setPotentialToDateRedux } from "../../../../../store/slices/filterSlice";
import { setFilteredNavData } from "../../../../../store/slices/LeadreportfilteredSlice";
import RemoveIcon from '@mui/icons-material/Remove';
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";


const PotentialStatusL1 = ({ wrapperClasses }) => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const USAComma = CommaConvert();

  const [potentialStatusDownload, setPotentialStatusDownload] = useState([]);
  const StatusdropdownRef = useRef(null);
  const [showsourseDropdown, setshowsourceDropdown] = useState(false);
  const [filteredLeadReportsLead, setFilteredLeadReportsLead] = useState([]);
  const { filteredReports } = useSelector((state) => state.filteredData);
  const [showgraph, setShowgraph] = useState(true);

  const handleToggleTable = () => {
    setShowgraph(!showgraph);
  };
  useEffect(() => {
    if (Array.isArray(filteredReports)) {
      setFilteredLeadReportsLead(filteredReports);
    }
  }, [filteredReports]);
  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        StatusdropdownRef.current &&
        !StatusdropdownRef.current.contains(event.target)
      ) {
        setshowsourceDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleDownload = (event) => {
    const value = event.target.value;

    if (value === "pdf") {
      downloadPDF();
    } else if (value === "word") {
      downloadWord();
    } else if (value === "excel") {
      downloadExcel();
    }
    setIsDropdownVisible(false);
  };

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
  };

  const downloadExcel = () => {
    const sortedLeads = [...potentialStatusDownload].sort(
      (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
    );

    const ws = XLSX.utils.json_to_sheet(
      sortedLeads.map((LeadReport, index) => ({
        "Sr. No": index + 1,
        "Lead Date": LeadReport.LeadDate
          ? formatDateByCountry(LeadReport.LeadDate)
          : " ",
        "Client Name": LeadReport.ClientName,
        "Project Name": LeadReport.ProjectName,
        "Lead Type": LeadReport.LeadType,
        "Quoted Value": USAComma(LeadReport.QuotedValue), // ✅ Ensure it's a number
        Source: LeadReport.Source,
        Status: LeadReport.Status,
        Group: LeadReport.AssignedGroup,
        "Follow-up Date":
          LeadReport.Status === "Won" || LeadReport.Status === "Lost"
            ? " "
            : formatDateByCountry(LeadReport.FollowupDate),
      }))
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], {
      bookType: "xlsx",
      type: "application/octet-stream",
    });
    saveAs(excelFile, "LeadReports.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "Sr. No",
          "Lead Date",
          "Client Name",
          "Project Name",
          "Lead Type",
          "Quoted Value",
          "Source",
          "Status",
          "Group",
          "Follow-up Date",
        ],
      ],
      body: potentialStatusDownload.map((LeadReport, index) => [
        index + 1,
        LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " ",
        LeadReport.ClientName,
        LeadReport.ProjectName,
        LeadReport.LeadType,
        `${currency}${USAComma(LeadReport.QuotedValue)}`,
        LeadReport.Source,
        LeadReport.Status,
        LeadReport.AssignedGroup,
        LeadReport.Status === "Won" || LeadReport.Status === "Lost"
          ? " "
          : formatDateByCountry(LeadReport.FollowupDate),
      ]),
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
    });
    doc.save("LeadReports.pdf");
  };

  const downloadWord = () => {
    const safeText = (value) => (value === null || value === undefined ? " " : String(value));
    const docxParagraphFromText = (value) =>
      new Paragraph({
        children: [new TextRun(safeText(value))],
      });
    const leadRows = (potentialStatusDownload || []).filter((row) => row != null);
    const headerRow = new TableRow({
      children: [
        new TableCell({
          children: [docxParagraphFromText("Sr.No")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Lead Date")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Client Name")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Project Name")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Lead Type")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Quoted Value")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Source")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Status")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Group")],
        }),
        new TableCell({
          children: [docxParagraphFromText("Follow-up Date")],
        }),
      ],
    });

    const dataRows = leadRows.map((LeadReport, index) => {
      return new TableRow({
        children: [
          new TableCell({
            children: [docxParagraphFromText(`${index + 1}`)],
          }),
          new TableCell({
            children: [
              docxParagraphFromText(
                LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " "
              ),
            ],
          }),
          new TableCell({
            children: [docxParagraphFromText(LeadReport.ClientName)],
          }),
          new TableCell({
            children: [docxParagraphFromText(LeadReport.ProjectName)],
          }),
          new TableCell({
            children: [docxParagraphFromText(LeadReport.LeadType)],
          }),
          new TableCell({
            children: [
              docxParagraphFromText(
                `${currency}${USAComma(LeadReport.QuotedValue)}`
              ),
            ],
          }),
          new TableCell({
            children: [docxParagraphFromText(LeadReport.Source)],
          }),
          new TableCell({
            children: [docxParagraphFromText(LeadReport.Status)],
          }),
          new TableCell({
            children: [docxParagraphFromText(LeadReport.AssignedGroup)],
          }),
          new TableCell({
            children: [
              docxParagraphFromText(
                LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                  ? " "
                  : formatDateByCountry(LeadReport.FollowupDate)
              ),
            ],
          }),
        ],
      });
    });

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [
            new Table({
              rows: [headerRow, ...dataRows],
            }),
          ],
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "LeadReports.docx");
    });
  };

  const popupRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsDropdownVisible(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (isDropdownVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownVisible]);

  const [totalGraphCount, setTotalGraphCount] = useState(0);
  const [potentialStatus, setPotentialStatus] = useState([]);

  const aggregatePotentialStatusData = useCallback(
    (filteredData, totalDenominatorCount) => {
      if (!Array.isArray(filteredLeadReportsLead) || filteredLeadReportsLead.length === 0) {
        return;
      }

      // Calculate total amount and count for filtered data
      const totalFilteredAmount = filteredData.reduce(
        (sum, lead) => sum + (lead.QuotedValue || 0),
        0
      );
      // Denominator = total leads (date-filtered, without status filter) so a selected status
      // is shown as selectedStatusCount / totalLeads instead of always 100%.
      const totalFilteredCount =
        (totalDenominatorCount ?? filteredData.length) || 1;
      setTotalGraphCount(totalFilteredCount);
      const totalCauculatedCount = filteredData.length;

      // Group data by status
      const groupedData = filteredData.reduce((acc, lead) => {
        // const status = lead.Status;
        const status = lead.Status?.toLowerCase() || "";
        if (!acc[status]) {
          acc[status] = [];
        }
        acc[status].push(lead);
        return acc;
      }, {});

      // Process each status group
      const statusData = Object.keys(groupedData).map((status) => {
        const leadsForStatus = groupedData[status];
        const totalQuotedAmount = leadsForStatus.reduce(
          (sum, lead) => sum + (lead.QuotedValue || 0),
          0
        );
        const count = leadsForStatus.length;
        // Always calculate percentage based on total unfiltered count
        const percentage = ((count / totalFilteredCount) * 100).toFixed(2);

        return {
          status,
          amount: totalQuotedAmount,
          count,
          percentage: parseFloat(percentage), // Convert to number for accurate summation
        };
      });
      // Calculate total percentage
      const totalPercentage = statusData
        .reduce((sum, status) => sum + status.percentage, 0)
        .toFixed(2);

      // Update state with aggregated data
      setPotentialStatus(statusData);
      setTotalStatusAmount(totalFilteredAmount);
      setTotalStatusCount(totalCauculatedCount);
      setTotalPercentage(totalPercentage); // Store total percentage in state
    },
    [filteredLeadReportsLead]
  );



  useEffect(() => {
    if (filteredReports) {
      aggregatePotentialStatusData(filteredReports);
      setPotentialStatusDownload(filteredReports);
    }
  }, [
    filteredReports,
    aggregatePotentialStatusData,
    filteredLeadReportsLead,
  ]);

  const [selectedTab, setSelectedTab] = useState("graph");
  const [statusFilterDateFrom, setStatusFilterDateFrom] = useState(null);
  const [statusFilterDateTo, setStatusFilterDateTo] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const [potentialStatusfinal] = useState("All");

  const [totalStatusAmount, setTotalStatusAmount] = useState(0);
  const [totalstatusCount, setTotalStatusCount] = useState(0);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const statusPieChart = useRef();
  const statusChartRef = useRef(null);
  const navigate = useNavigate();

  const handleFromDateChange = (date) => {
    if (!date) return;
    setStatusFilterDateFrom(date);
    dispatch(setPotentialFromDateRedux(date));
  };
  const handleToDateChange = (date) => {
    if (!date) return;
    setStatusFilterDateTo(date);
    dispatch(setPotentialToDateRedux(date))
  };
  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setshowsourceDropdown(false); // Close dropdown after selection
    dispatch(setPotentialStatusRedux(status))
  };


  const [statuses, setStatuses] = useState([]);

  const { status } = useSelector((state) => state.status);
  const statusFilterDateFromRedux = useSelector((state) => state.filters.statusFilterDateFrom);
  const statusFilterDateToRedux = useSelector((state) => state.filters.statusFilterToFrom);
  const statusPotentialRedux = useSelector((state) => state.filters.statusFilter);

  useEffect(() => {
    if (statusFilterDateFromRedux !== undefined && statusFilterDateFromRedux !== null) {
      setStatusFilterDateFrom(statusFilterDateFromRedux);
    } else {
      setStatusFilterDateFrom(null);
    }
  }, [statusFilterDateFromRedux]);


  useEffect(() => {
    if (statusFilterDateToRedux !== undefined && statusFilterDateToRedux !== null) {
      setStatusFilterDateTo(statusFilterDateToRedux)
    } else {
      setStatusFilterDateTo("")
    }
  }, [statusFilterDateToRedux])

  useEffect(() => {
    if (statusPotentialRedux !== undefined && statusPotentialRedux !== null) {
      setStatusFilter(statusPotentialRedux)
    } else {
      setStatusFilter("All")
    }
  }, [statusPotentialRedux])

  useEffect(() => {
    dispatch(fetchStatus());
  }, [dispatch]);

  useEffect(() => {
    if (status.length > 0) {
      setStatuses(status);
    }
  }, [status]);

  const sortedStatuses = [...statuses].sort((a, b) => {
    // Spread operator to create a new array
    const order = ["Won", "Won Recurring", "Pending", "Lost"];
    const indexA = order.indexOf(a.status);
    const indexB = order.indexOf(b.status);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  const handlePotentialStatusFilter = () => {
    const normalize = (value) => String(value ?? "").trim().toLowerCase();
    const selectedStatus = normalize(statusFilter);
    // Date-filtered (without status) — used as the denominator for percentage
    const dateFilteredData = filteredLeadReportsLead.filter((item) => {
      const itemDate = new Date(item.LeadDate);
      return (
        (!statusFilterDateFrom || itemDate >= statusFilterDateFrom) &&
        (!statusFilterDateTo || itemDate <= statusFilterDateTo)
      );
    });
    // Filter data based on date range and status selection
    const filteredData = dateFilteredData.filter((item) => {
      const isMatchingStatus =
        !selectedStatus ||
        selectedStatus === "all" ||
        normalize(item.Status) === selectedStatus;
      return isMatchingStatus;
    });
    // Update state or pass filtered data for further processing
    aggregatePotentialStatusData(filteredData, dateFilteredData.length);
    setPotentialStatusDownload(filteredData);
  };


  const potentialNavigationl1 = useCallback(
    (clickedStatus) => {
      const filteredDatapotentiall1 = potentialStatusDownload.filter(
        (item) => item.Status === clickedStatus
      );
      dispatch(setFilteredNavData(filteredDatapotentiall1));

      navigate(`/dashboard/lead-report`);
    },
    [potentialStatusDownload, navigate, dispatch]
  );

  // useEffect(() => {
  //   const renderStatusChart = () => {
  //     if (potentialStatus.length > 0 && selectedTab === "graph") {
  //       const ctxStatus = statusPieChart.current;

  //       if (statusChartRef.current) {
  //         statusChartRef.current.destroy();
  //       }

  //       const statusOrder = ["Won", "Won Recurring", "Pending", "Lost"];
  //       const sortedPotentialStatus = [...potentialStatus].sort(
  //         (a, b) =>
  //           statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status)
  //       );

  //       const completePotentialStatus = statusOrder.map((status) => {
  //         const found = sortedPotentialStatus.find(
  //           (item) => item.status === status
  //         );
  //         return found ? found : { status, count: 0 };
  //       });

  //       const customDefaultLabelPlugin = {
  //         id: "customDefaultLabel",
  //         afterDatasetsDraw(chart) {
  //           const { ctx, data } = chart;
  //           ctx.save();
  //           ctx.font = "bold 14px Arial";
  //           ctx.textAlign = "center";
  //           ctx.textBaseline = "middle";

  //           data.datasets.forEach((dataset, datasetIndex) => {
  //             dataset.data.forEach((value, index) => {
  //               const meta = chart.getDatasetMeta(datasetIndex);
  //               const bar = meta.data[index];

  //               if (bar && value !== null) {
  //                 const { x, y } = bar.tooltipPosition();
  //                 const percentage = ((value / totalGraphCount) * 100).toFixed(
  //                   2
  //                 );
  //                 const adjustedY = y - 6;

  //                 ctx.fillStyle = "black";
  //                 const numericPercentage = Number(percentage);
  //                 if (numericPercentage !== 0) {
  //                   ctx.fillText(`${numericPercentage}%`, x, adjustedY);
  //                 }
  //               }
  //             });
  //           });

  //           ctx.restore();
  //         },
  //       };

  //       statusChartRef.current = new Chart(ctxStatus, {
  //         type: "bar",
  //         data: {
  //           labels: completePotentialStatus.map((item) => item.status),
  //           datasets: [
  //             {
  //               label: "Percentage",
  //               borderRadius: 8,
  //               data: completePotentialStatus.map((item) =>
  //                 potentialStatusfinal === "All" ||
  //                   item.status === potentialStatusfinal
  //                   ? item.count
  //                   : 0
  //               ),
  //               backgroundColor: ["#15803d", "#89AC46", "orange", "#DC2626"],
  //             },
  //           ],
  //         },
  //         options: {
  //           responsive: true,
  //           maintainAspectRatio: false,
  //           plugins: {
  //             legend: { display: false },
  //             tooltip: { enabled: false },
  //           },
  //           onClick: (event, elements) => {
  //             if (elements.length > 0) {
  //               const clickedElementIndex = elements[0].index;
  //               const clickedStatus =
  //                 completePotentialStatus[clickedElementIndex].status;
  //               potentialNavigationl1(clickedStatus);
  //             }
  //           },
  //           scales: {
  //             x: {
  //               border: {
  //                 color: "black",
  //               },
  //               grid: { display: false },
  //               ticks: {
  //                 color: "black",
  //                 font: {
  //                   size: 14,
  //                   weight: "bold",
  //                 },
  //               },
  //             },
  //             y: {
  //               display: false,
  //               grid: { display: false },
  //               ticks: { display: false },
  //               beginAtZero: true,
  //               suggestedMax:
  //                 Math.max(
  //                   ...completePotentialStatus.map((item) => item.count)
  //                 ) * 1.2,
  //             },
  //           },
  //         },
  //         plugins: [customDefaultLabelPlugin],
  //       });
  //     }
  //   };
  //   renderStatusChart();
  // }, [
  //   potentialStatus,
  //   potentialStatusfinal,
  //   selectedTab,
  //   totalGraphCount,
  //   potentialNavigationl1,
  //   showgraph
  // ]);


  const renderStatusChart = React.useCallback(() => {
    // Check if canvas element exists and data is available
    if (!statusPieChart.current || potentialStatus.length === 0 || selectedTab !== "graph") {
      return;
    }

    const ctxStatus = statusPieChart.current.getContext('2d');

    // Destroy previous chart instance if it exists
    if (statusChartRef.current) {
      statusChartRef.current.destroy();
    }

    const statusOrder = ["Won", "Won Recurring", "Pending", "Lost"];
    const sortedPotentialStatus = [...potentialStatus].sort(
      (a, b) => statusOrder.indexOf(a.status.toLowerCase()) - statusOrder.indexOf(b.status.toLowerCase())
    );

    const completePotentialStatus = statusOrder.map((status) => {
      const found = sortedPotentialStatus.find(
        (item) => item.status.toLowerCase() === status.toLowerCase()
      );
      return found ? found : { status, count: 0 };
    });

    const customDefaultLabelPlugin = {
      id: "customDefaultLabel",
      afterDatasetsDraw(chart) {
        const { ctx, data } = chart;
        ctx.save();
        ctx.font = "bold 14px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        data.datasets.forEach((dataset, datasetIndex) => {
          dataset.data.forEach((value, index) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            const bar = meta.data[index];

            if (bar && value !== null) {
              const { x, y } = bar.tooltipPosition();
              const percentage = ((value / totalGraphCount) * 100).toFixed(2);
              const adjustedY = y - 6;

              ctx.fillStyle = "black";
              const numericPercentage = Number(percentage);
              if (numericPercentage !== 0) {
                ctx.fillText(`${numericPercentage}%`, x, adjustedY);
              }
            }
          });
        });

        ctx.restore();
      },
    };

    statusChartRef.current = new Chart(ctxStatus, {
      type: "bar",
      data: {
        labels: completePotentialStatus.map((item) => item.status),
        datasets: [
          {
            label: "Percentage",
            borderRadius: 8,
            data: completePotentialStatus.map((item) =>
              potentialStatusfinal === "All" || item.status === potentialStatusfinal
                ? item.count
                : 0
            ),
            backgroundColor: ["#15803d", "#89AC46", "orange", "#DC2626"],
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const clickedElementIndex = elements[0].index;
            const clickedStatus =
              completePotentialStatus[clickedElementIndex].status;
            potentialNavigationl1(clickedStatus);
          }
        },
        scales: {
          x: {
            border: {
              color: "black",
            },
            grid: { display: false },
            ticks: {
              color: "black",
              font: {
                size: 14,
                weight: "bold",
              },
            },
          },
          y: {
            display: false,
            grid: { display: false },
            ticks: { display: false },
            beginAtZero: true,
            suggestedMax:
              Math.max(
                ...completePotentialStatus.map((item) => item.count)
              ) * 1.2,
          },
        },
      },
      plugins: [customDefaultLabelPlugin],
    });
  }, [
    potentialStatus,
    selectedTab,
    totalGraphCount,
    potentialStatusfinal,
    potentialNavigationl1,
    statusPieChart,
    statusChartRef
  ]);

  // In your useEffect:
  useEffect(() => {
    renderStatusChart();

    // Cleanup function to destroy chart when component unmounts
    return () => {
      if (statusChartRef.current) {
        statusChartRef.current.destroy();
        statusChartRef.current = null;
      }
    };
  }, [renderStatusChart, showgraph]);


  return (
    <div className=" w-full h-full justify-center"
      style={{ fontFamily: "Lora", fontWeight: 600 }}>
      <div className="min-h-[10%] px-3 rounded-md bg-white">
        <div className=" flex  flex-wrap justify-between items-center align-middle md:gap-x-2 sm:gap-x-2 md:flex-nowrap xl:flex xl:justify-between xl:gap-x-8">
          <div className="flex gap-2">
            <h1 className="text-2xl font-semibold flex gap-2 sm:text-sm md:text-sm lg:text-xl">
              POTENTIAL STATUS
            </h1>

          </div>
          <div className=" md:flex lg:ml-20 lg:flex lg:items-center lg:justify-end xl:flex xl:justify-end">
            <div className="show-potential-download  text-3xl">
              <div className=" inline-block relative px-3 mt-2">
                <div ref={popupRef} className="flex items-center text-4xl sm:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-4xl">
                  <CloudDownloadIcon
                    onClick={toggleDropdown}
                    className="cursor-pointer"
                  // fontSize="4rem"
                  />

                  {isDropdownVisible && (
                    <div

                      className="absolute top-8 -left-0 shadow-lg z-50 bg-white text-base"
                    >
                      <div
                        className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() =>
                          handleDownload({ target: { value: "pdf" } })
                        }
                      >
                        PDF
                      </div>
                      <div
                        className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() =>
                          handleDownload({ target: { value: "excel" } })
                        }
                      >
                        Excel
                      </div>
                      <div
                        className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() =>
                          handleDownload({ target: { value: "word" } })
                        }
                      >
                        Word
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="show-potential-download lg:justify-end">
              <div className=" flex items-center justify-between text-3xl sm:text-xl md:text-md">
                {selectedTab === "table" && (
                  <span title="Graph">
                    <SignalCellularAltIcon
                      className="cursor-pointer"
                      onClick={() => setSelectedTab("graph")}
                    // fontSize="3rem"
                    />
                  </span>
                )}

                {selectedTab === "graph" && (
                  <span title="Table">
                    <TableChartIcon
                      className="cursor-pointer"
                      onClick={() => setSelectedTab("table")}
                    // fontSize="3rem"
                    />
                  </span>
                )}
              </div>
            </div>
            <div onClick={() => handleToggleTable()} className="ml-4 mt-1 flex justify-center align-middle items-center border rounded-md ">
              <RemoveIcon
                className=" cursor-pointer"
              />
            </div>
          </div>
        </div>
        <hr />
        <hr />
      </div>

      {showgraph && (
        <div className="h-[23.5rem] rounded-b-lg">
          <div className="bg-white flex gap-3 px-3 items-center w-full justify-between pt-1 lg:flex-nowrap lg:gap-2">
            <div className="flex justify-between align-middle items-center w-full gap-1">
              <div className="w-[25%] flex align-middle p-1 border border-[#e3eaff] rounded-md ">
                <div className="pl-1 pt-1.5 text-xs">
                  <p>From-</p>
                </div>
                <div className="h-full w-full">
                  <DatePicker
                    selected={statusFilterDateFrom}
                    onChange={handleFromDateChange}
                    dateFormat={getDateFormat()}
                    className=" w-full h-full text-xs outline-none date-picker-placeholder"
                    placeholderText={getDatePlaceholder()}
                    maxDate={new Date()}
                    required
                  />
                </div>
              </div>
              |
              <div className="w-[25%] flex align-middle p-1 border border-[#e3eaff] rounded-md ">
                <div className="pl-1 pt-1.5 text-xs">
                  <p>To-</p>
                </div>
                <div className="h-full w-full ">
                  <DatePicker
                    selected={statusFilterDateTo}
                    onChange={handleToDateChange}
                    dateFormat={getDateFormat()}
                    className="w-full h-full text-xs outline-none date-picker-placeholder"
                    placeholderText={getDatePlaceholder()}
                    required
                    minDate={
                      statusFilterDateFrom
                        ? new Date(statusFilterDateFrom.getTime() + 86400000)
                        : null
                    }
                  />
                </div>
              </div>
              <div className="relative flex align-middle items-center w-[25%]">
                {/* <div className="text-xs h-full bg-[#6b7280] text-white p-0.5 flex align-middle items-center text-center">
                Select
              </div> */}
                <div className="absolute cursor-pointer right-0 border-r border-[#e3eaff] bg-white z-20">
                  <ExpandMoreIcon
                    color="white"
                    className=""
                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                  />
                </div>
                <div
                  ref={StatusdropdownRef}
                  className="relative border w-full border-[#e3eaff]  rounded-md"
                >
                  <button
                    type="button"
                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                    className=" flex justify-start items-center align-middle w-full h-full p-2 text-nowrap truncate focus:outline-none text-xs"
                  >
                    {statusFilter}
                  </button>

                  {showsourseDropdown && (
                    <div className="absolute flex flex-col w-28 p-0.5 gap-2 z-50  bg-white text-xs border border-gray-300 overflow-y-auto shadow-lg max-h-48  mt-0.5">
                      <label
                        htmlFor="All"
                        className="p-1 hover:bg-gray-300"
                        onClick={() => handleStatusChange("All")}
                      >
                        All
                      </label>

                      {sortedStatuses.map((statuse) => (
                        <label
                          key={statuse.id}
                          value={statuse.status}
                          className="p-1 hover:bg-gray-300"
                          onClick={() => handleStatusChange(statuse.status)}
                        >
                          {statuse.status}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="w-[25%] flex justify-end">
                <button
                  className="text-white bg-[#e32278] p-2 px-4 text-xs rounded-md max-w-24 shadow-md"
                  onClick={handlePotentialStatusFilter}
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
          <div className=" h-[21rem] flex bg-white px-3 pb-2 rounded-b-md">
            {selectedTab === "table" ? (
              potentialStatus.length > 0 ? (
                <div className="w-full pt-3">
                  <div className=" overflow-auto max-h-[18rem] ">
                    <table className="w-full divide-y divide-gray-200">
                      <thead className="bg-black sticky top-0">
                        <tr className="text-white">
                          <th className="px-3 py-2 text-left border text-sm font-medium capitalize tracking-wider">
                            Status
                          </th>
                          <th className="px-3 py-2 text-center border text-sm font-medium capitalize tracking-wider">
                            Count
                          </th>
                          <th className="px-3 py-2 text-center border text-sm font-medium capitalize tracking-wider">
                            %
                          </th>
                          <th className="px-3 py-2 text-right border text-sm font-medium capitalize tracking-wider">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {potentialStatus
                          .sort((a, b) => {
                            const statusOrder = [
                              "WON",
                              "WON RECURRING",
                              "PENDING",
                              "LOST",
                            ];
                            return (
                              statusOrder.indexOf(a.status.toUpperCase()) -
                              statusOrder.indexOf(b.status.toUpperCase())
                            );
                          })
                          .map((item, index) => (
                            <tr className="border text-[16px]" key={index}>
                              <td
                                onClick={() => potentialNavigationl1(item.status)}
                                style={{ cursor: "pointer" }}
                                className="px-2 text-left py-1 font-thin"
                              >
                                {item.status.toUpperCase()}
                              </td>
                              <td className="px-2 text-center py-1">
                                {item.count}
                              </td>
                              <td className="px-2 text-center py-1">
                                {item.percentage} %
                              </td>
                              <td className="px-2 text-right py-1">
                                {currency}
                                {USAComma(item.amount)}
                              </td>
                            </tr>
                          ))}
                        <tr className="border bg-gray-200 font-bold text-[16px]">
                          <td className="px-3 text-left py-2">TOTAL :</td>
                          <td className="px-3 text-center py-2">
                            {totalstatusCount}
                          </td>

                          <td className="px-3 text-center py-2">
                            {totalPercentage === "99.99" ? 100 : totalPercentage}%
                          </td>

                          {/* <td className="px-3 text-center py-2">{totalPercentage}</td> */}
                          <td className="px-3 text-right py-2">
                            {currency}
                            {USAComma(totalStatusAmount)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center align-middle items-center text-center  w-full">
                  <p className="noDataAvailable">
                    No data available
                  </p> </div>
              )
            ) : potentialStatus.length > 0 ? (
              <canvas id="statusPieChart" ref={statusPieChart}></canvas>
            ) : (
              <div className="flex justify-center align-middle items-center text-center  w-full">
                <p className="noDataAvailable">
                  No data available
                </p> </div>

            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PotentialStatusL1;
